import React, { Component } from "react";
import classnames from "classnames";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";
import { Icon } from "@formant/ui/component/common/Icon";

import { StandardButton } from "../common/StandardButton";
import * as styles from "./AddButton.scss";

export interface IAddButtonProps extends ITestableComponentProps {
    label: string;
    count: number;
    max?: number;
    returnMouseEventByDefault?: boolean;
    minimal?: boolean;
    className?: string;
    onClicked: (event?: React.MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
    tooltips?: [string, string];
}

export class AddButton extends Component<IAddButtonProps> {
    public render() {
        const {
            label,
            count,
            max,
            className,
            returnMouseEventByDefault,
            onClicked,
            disabled,
            tooltips,
            minimal,
        } = this.props;
        const existingMax = max !== undefined;
        const showCount = existingMax && count > 0 && max > 0;
        const maxed = existingMax && count >= max;
        const [tooltip, maxedTooltip] = tooltips || [];

        return (
            <StandardButton
                className={classnames(
                    styles["add-button"],
                    styles.button,
                    minimal && styles.minimalist,
                    className,
                )}
                onClicked={onClicked}
                returnMouseEventByDefault={returnMouseEventByDefault}
                minimal={minimal}
                disabled={disabled || maxed}
                data-tooltip={maxed ? maxedTooltip : tooltip}
                data-testid={this.props["data-testid"]}
            >
                <div className={styles.label}>{label}</div>
                {showCount && max > 1 && (
                    <div>
                        <span>{count}</span> of <span>{max}</span>
                    </div>
                )}
                <Icon className={styles.icon} name="add" />
            </StandardButton>
        );
    }
}
